import React from 'react';

import { Icon, Label } from '@atlas/ui';

const SimpleEmptyOutcomesRow = () => (
  <div className="tournament-scroll-outcomes-row">
    <div className="other-markets">
      <div className="other-markets-content">
        <Label message="other_markets" />
        <Icon className="icon-m-arrow-right" name="m-arrow-right" />
      </div>
    </div>
  </div>
);

export default SimpleEmptyOutcomesRow;
